import { LabMDM } from "./lab";
import { MachineType } from "./machineType";
import { Printer } from "./printer";
import { ProcessStep } from "./processStep-enum";
import { Template } from './template';

//this model is used to define the status of the carrier
export class  CarrierState{

    _id: string;
	/** The status of the concerned carrier. */
	name: ProcessStep ;
    
    /** The lab where the concerned carrier is being processed. */
    lab:LabMDM;

	/** stores if the boolean value is active or not */
    active:boolean;

    machineType: MachineType;

    printer: Printer;

    defaultTemplate: Template;

    nextStep: ProcessStep;

    processList:boolean;

    platePrefixes: string;

    extraField1: string;

    inputCheck1: string;

    extraField2: string;

    inputCheck2: string;
}